import { h } from 'preact';
import PropTypes from 'prop-types';
import { forwardRef } from 'preact/compat';

import { getAudioType } from './helpers/get-audio-type';

const Audio = forwardRef(({ src }, ref) => (
  <audio controls ref={ref}>
    <source src={src} type={getAudioType(src)} />
  </audio>
));

Audio.propTypes = {
  src: PropTypes.string,
};

export default Audio;
